// extracted by mini-css-extract-plugin
export default {"TextArea":"TextArea_TextArea__nYael","focused":"TextArea_focused__-1lKU"};